// See  https://reactjs.org/docs/integrating-with-other-libraries.html

import * as React from "react";
import * as toastr from "toastr";

import { IText_DateAndTimePickerInternationalisedText } from "../../calendar/classes/text_AddEditEvent";

import * as dates from "../../calendar/reducers/changeTimePeriod";

import $ from "jquery";

import "jquery-ui-dist/jquery-ui";
import "jquery-ui/ui/widget";
import "jquery-ui/ui/widgets/datepicker";

import "jquery-ui-timepicker-addon";

// Only import the jquery-ui CSS in dev. The jquery-ui CSS is already in the CMS, and causes CSS conflicts if we include this CSS sheet in the React build.
if (process.env.NODE_ENV === "development") {
    require("jquery-ui-themes/themes/smoothness/jquery-ui.css"); // tslint:disable-line
}

import { IDateStruct } from "../../calendar/classes/data";

interface IJQDateAndTimePickerProps {
    currentDate: Date; // The date+time currently set in the date picker's UI.
    displayTimePickerUI: boolean;
    firstDayOfWeek: string;
    getLatestDateNowForUser: () => any; // This is a call to an asynch service which returns promise of user's current datetime in thir time zone... not linked into Redux flow.
    hasTopPadding?: boolean;
    id: string;
    inputElementAdditionalCSS?: string;
    inputElementHardCodedStyle?: object;
    minimumDate?: Date | number | string;
    onBlurSelectedDate: () => void;
    onChangeSelectedDate: (newDate: Date) => void;
    showAboveInput?: boolean;
    showCloseButton?: boolean;
    text: IText_DateAndTimePickerInternationalisedText;
    userDateFormat: string;
    userTimeFormat?: string;
}

export class JQDateAndTimePicker extends React.Component<IJQDateAndTimePickerProps, {}> {

    public datePickerInput = React.createRef<HTMLInputElement>();
    public datePickerDiv = React.createRef<HTMLDivElement>();

    public constructor(props: IJQDateAndTimePickerProps, context: {}) {
        super(props, context);
    }

    public componentDidMount() {
        this.initialiseDatePicker();
        this.removeHrefFromNextAndPreviousLinks();
    }

    public componentDidUpdate(prevProps: IJQDateAndTimePickerProps) {
        // If change from All Day event to Non-All Day event, have to re-render because we're switching from a DatePicker to a DateTimePicker (or vice versa).
        if (prevProps.displayTimePickerUI !== this.props.displayTimePickerUI) {
            this.getDatePickerRoot().datetimepicker("destroy");
            this.initialiseDatePicker();
        }
    }

    public componentWillUnmount() {
        this.getDatePickerRoot().datetimepicker("destroy");
    }

    public render() {
        let dateString: string = "";
        if (this.props.currentDate) {
            dateString = dates.format(this.props.currentDate, this.props.userDateFormat, this.props.displayTimePickerUI, this.props.userTimeFormat);
        }

        let cssClasses = "dateTime CMS_input";
        if (this.props.inputElementAdditionalCSS) { cssClasses = cssClasses + " " + this.props.inputElementAdditionalCSS; }

        let style = {};
        if (this.props.inputElementHardCodedStyle) { style = this.props.inputElementHardCodedStyle; }

        let placeholder = "";
        if (this.props.text && this.props.text.placeHolderText) { placeholder = this.props.text.placeHolderText; }

        return (
            <input className={cssClasses} style={style} type="text" value={dateString} placeholder={placeholder} onBlur={this.onBlurDate} ref={this.datePickerInput} readOnly />
        );
    }

    private initialiseDatePicker() {

        if (this.props.displayTimePickerUI) {
            this.setUpDatePickerWithTimePicker();
        } else {
            this.setUpDatePickerWithoutTimePicker();
        }
        this.replaceDefaultNowButtonHandler();

        // add href to prev/next anchors so that they can receive TAB focus
        $(".ui-datepicker-prev, .ui-datepicker-next").attr("href", "#");
        $(".ui-datepicker-prev, .ui-datepicker-next").attr("tabIndex", "1");
    }

    private replaceDefaultNowButtonHandler = () => {
        // Replace the standard handler in the library used when user clicks 'Now' button, which only selects (but does not set) the date to the local machine time.
        jQuery.datepicker._gotoToday = (a) => {
            this.getNowDateFromServiceAndSetInDatePicker();
            return;
        };
    }

    private getNowDateFromServiceAndSetInDatePicker = () => {
        this.disableDatePicker(true);
        this.props.getLatestDateNowForUser().then((response: any) => {
            if (response.error) {
                toastr.error(response.error);
            } else {
                this.setTheDatePickerDateToTheResponse(response);
            }
            this.disableDatePicker(false);
        }).catch((error) => {
            toastr.error(error);
        });
    }

    private setTheDatePickerDateToTheResponse = (response: any): void => {
        if (response.d !== undefined) { response = response.d; } // .NET service wraps response in a 'd' property.
        const dateNowForUser: IDateStruct = response;
        const newDate = new Date(dateNowForUser.year, dateNowForUser.month, dateNowForUser.day, dateNowForUser.hour, dateNowForUser.minute, 0, 0);
        this.props.onChangeSelectedDate(newDate);
        this.getDatePickerRoot().datepicker("setDate", newDate);
    }

    private removeHrefFromNextAndPreviousLinks() {
        // PRES-6547: The Datepicker Next and Previous month links initially have an "href='#'" which causes the page to reload
        // when clicked when in friendly URL mode. I suspect the JQuery library is missing an event.preventDefault() on these.
        $(".ui-datepicker-next").removeAttr("href");
        $(".ui-datepicker-prev").removeAttr("href");
    }

    private getDatePickerRoot = (): any => {
        return $(this.datePickerInput.current);
    }

    private setUpDatePickerWithTimePicker = () => {
        // See https://trentrichardson.com/examples/timepicker/ ... the JQuery datepicker extended with a timepicker

        const dateFormat = this.convertUserDateFormatToDatePickerDateFormat();
        const that = this;

        const dateAndTimePickerSettings = {
            beforeShow: (input, inst) => {
                if (that.props.showAboveInput === true) {
                    // Handle calendar position before showing it. https://javascriptio.com/view/42472/how-to-change-the-pop-up-position-of-the-jquery-datepicker-control
                    const calendar = inst.dpDiv;
                    setTimeout(() => {
                        calendar.position({ my: "left bottom", at: "left top", collision: "none", of: input });
                    }, 1);
                }
            },
            controlType: "select",
            dateFormat,
            firstDay: dates.getDayNumberByName(this.props.firstDayOfWeek),
            minDate: this.props.minimumDate,
            onSelect: this.datePicker_onSelect,
            oneLine: true,
            showButtonPanel: true,
            showCloseButton: this.props.showCloseButton,
            showTimepicker: true,
            timeFormat: this.getTimeFormat(this.props.displayTimePickerUI),
            ...this.props.text, // Using spread operator to add all the text object properties to this object.
        };

        this.getDatePickerRoot().datetimepicker(dateAndTimePickerSettings);
        this.getDatePickerRoot().datetimepicker("setDate", this.props.currentDate);
    }

    private setUpDatePickerWithoutTimePicker = () => {
        // See http://api.jqueryui.com/datepicker/

        const dateFormat = this.convertUserDateFormatToDatePickerDateFormat();
        const that = this;

        const datePickerSettings = {
            beforeShow: (input, inst) => {
                if (that.props.showAboveInput === true) {
                    // Handle calendar position before showing it. https://javascriptio.com/view/42472/how-to-change-the-pop-up-position-of-the-jquery-datepicker-control
                    const calendar = inst.dpDiv;
                    setTimeout(() => {
                        calendar.position({ my: "left bottom", at: "left top", collision: "none", of: input });
                    }, 1);
                }
            },
            dateFormat,
            firstDay: dates.getDayNumberByName(this.props.firstDayOfWeek),
            minDate: this.props.minimumDate,
            onChangeMonthYear: (year, month, inst) => {
                setTimeout(() => {
                    // add href to prev/next anchors so that they can receive TAB focus
                    $(".ui-datepicker-prev, .ui-datepicker-next").attr("href", "#");
                    $(".ui-datepicker-prev, .ui-datepicker-next").attr("tabIndex", "1");
                }, 50);
            },
            onSelect: this.datePicker_onSelect,
            showButtonPanel: true,
            showCloseButton: this.props.showCloseButton,
            ...this.props.text, // Using spread operator to add all the text object properties to this object.
        };

        this.getDatePickerRoot().datepicker(datePickerSettings);
        this.getDatePickerRoot().datepicker("setDate", this.props.currentDate);
    }

    private datePicker_onSelect = (dateText) => {
        const newDate = this.getDatePickerRoot().datetimepicker("getDate");
        newDate.setSeconds(0);
        newDate.setMilliseconds(0);
        this.props.onChangeSelectedDate(newDate);
    }

    private disableDatePicker = (disabled: boolean): void => {
        this.getDatePickerRoot().datepicker("option", "disabled", disabled);
    }

    private getTimeFormat = (displayTimePickerUI: boolean): string => {
        if (displayTimePickerUI) {
            if (this.props.userTimeFormat) { return this.convertUserTimeFormatToDatePickerDateFormat(); }
            return "h:mmTT";
        }
        return "";
    }

    private convertUserDateFormatToDatePickerDateFormat = (): string => {
        // This switches the user date format to the format used by the date picker control (see http://api.jqueryui.com/datepicker/#utility-formatDate)

        let datePickerFormat = "";
        switch (this.props.userDateFormat) {
            case "M/d/yyyy": datePickerFormat = "m/d/yy"; break;                // 2/28/2008                                - Verified
            case "M/d/yy": datePickerFormat = "m/d/y"; break;                   // 2/28/08                                  - Verified
            case "MM/dd/yy": datePickerFormat = "mm/dd/y"; break;               // 02/28/08                                 - Verified
            case "MM/dd/yyyy": datePickerFormat = "mm/dd/yy"; break;            // 02/28/2008                               - Verified
            case "MM/DD/YYYY": datePickerFormat = "mm/dd/yy"; break;            // 02/28/2008                               - Verified
            case "yy/MM/dd": datePickerFormat = "y/mm/dd"; break;               // 08/02/28                                 - Verified
            case "yyyy-MM-dd": datePickerFormat = "yy-mm-dd"; break;            // 2008-02-28                               - Verified
            case "dd-MMMM-yy": datePickerFormat = "dd-MM-y"; break;             // 28-February-08                           - Verified
            case "dd-MMM-yy": datePickerFormat = "dd-M-y"; break;               // 28-Feb-08                                - Verified
            case "dd MMMM, yyyy": datePickerFormat = "dd MM, yy"; break;         // 28 February, 2008                       - Verified
            case "MMMM dd, yyyy": datePickerFormat = "MM dd, yy"; break;         // February 28, 2008                       - Verified
            case "ddd, MMM dd, yyyy": datePickerFormat = "D, M dd, yy"; break;    // Thu, Feb 28, 2008                      - Verified
            case "dddd,dd MMMM, yyyy": datePickerFormat = "DD,dd MM, yy"; break;  // Thursday,28 February, 2008             - Verified
            case "dddd, MMMM dd, yyyy": datePickerFormat = "DD, MM dd, yy"; break;         // Thursday, February 28, 2008   - Verified
            case "MMMM Do yyyy": datePickerFormat = "MM d, yy"; break;        // February 28th 2008... datepicker does not have a number suffix symbol. Option not actually available.
            default: datePickerFormat = "yy-mm-dd";                             // Default format for blank/unrecognised time format.
        }

        return datePickerFormat;
    }

    private convertUserTimeFormatToDatePickerDateFormat = (): string => {
        // This switches the user time format to the format used by the date picker time picker add-pn control (see https://trentrichardson.com/examples/timepicker/)
        let datePickerFormat = "";
        switch (this.props.userTimeFormat) {
            case "h:mma": datePickerFormat = "h:mmtt"; break;                   // "12:25am";
            default: datePickerFormat = "h:mmTT";                               // "12:25AM" Default format for blank/unrecognised time format.
        }

        return datePickerFormat;
    }

    private onBlurDate = (event: React.ChangeEvent<HTMLInputElement>): void => {
        event.preventDefault();
        this.props.onBlurSelectedDate();
    }

};
